import { Component } from '@angular/core';
import { FeedbackPlatformUserNotificationSettingEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'User Notification Settings') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-feedbackplatformusernotificationsetting-form',
    templateUrl: './feedbackplatformusernotificationsetting.form.component.html'
})
export class FeedbackPlatformUserNotificationSettingFormComponent extends BaseFormComponent {
    public record!: FeedbackPlatformUserNotificationSettingEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

